/**
 * Created by glopez on 24/04/17.
 */

import _ from 'lodash';

/**
 * Returns whether or not the response is valid.
 *
 * @param {Object} response - Response.
 * @returns {boolean} True or false.
 */
export function isValidResponse (response) {

    return !_.get(response, ['result', 'error']);
}


// WEBPACK FOOTER //
// ./src/js/datasources/kaltura/validators/epg.js